import { render, staticRenderFns } from "./MarkAsTentative.vue?vue&type=template&id=0e79c2d8&"
import script from "./MarkAsTentative.vue?vue&type=script&lang=js&"
export * from "./MarkAsTentative.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsTentative.vue?vue&type=style&index=0&id=0e79c2d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports